import React, { Component } from "react";
import {
  View,
  Dimensions,
  TouchableHighlight,
  KeyboardAvoidingView,
  StyleSheet,
  Platform,
  ScrollView,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import ArTheme from "../argon-ui/Theme";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faCalendar, FONT_FAMILIES } from "../../assets/consts/faCharCodes";
import Loading from "../components/Loading";
import * as Actions from "../actions/ApiActions";
import CreditCard from "./components/CreditCard";
import { englishToPersianNumber } from "../util";
import TransactionListItem from "./components/TransactionListItem";
import { IconButton } from "../components_v2/Buttons";
import FilterItem from "../components_v2/FilterItem";
import { translate } from "../locales/translate";
import PersianCalendarPicker from "react-native-persian-calendar-picker";
import Select from "../nativeBase-ui/Select";
import { getIconPicture } from "./components/Icons";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import { HStack, Toast } from "native-base";
import ToastAlert from "../nativeBase-ui/ToastAlert";
import ModalBase from "../nativeBase-ui/ModalBase";
import { ArButton } from "../argon-ui";

let moment = require("moment-jalaali");

const SCREEN_WIDTH = Dimensions.get("window").width;
class IncreaseCreditScreen extends Component {
  constructor(props) {
    super(props);

    this.orderTypes = ["ALL"];
    this.orderStatus = ["ALL"];
    this._sortModes = {
      sortByTime: "orderSortByTime",
      sortByType: "orderSortByType",
      getArray: () => {
        var arr = [];
        for (var i in this._sortModes) {
          if (
            this._sortModes[i] &&
            {}.toString.call(this._sortModes[i]) === "[object Function]"
          ) {
            continue;
          }
          arr.push({
            label: translate(`api.${this._sortModes[i]}`),
            value: this._sortModes[i],
          });
        }
        if (Platform.OS == "web") {
          arr.unshift({
            label: translate("app.orderSortBy"),
            value: "orderSortBy",
          });
        }
        return arr;
      },
    };

    this.state = {
      accessToken: "",
      serverUrl: "",
      isLoadingError: true,
      isLoadingError: false,
      isUserValid: "",
      orderUnitId: null,
      userUnit: null,
      userBalance: null,
      unitBalance: null,
      paymentOnlineUserUrl: null,
      paymentOnlineUnitUrl: null,
      userRole: "Admin",
      userAmount: 500,
      unitAmount: 500,
      baseUnitAmount: 500,
      baseUserAmount: 500,
      userAmountType: "",
      unitAmountType: "",
      userAdminUnitAmount: [],
      isIncreaseCredit: false,
      isNewOrder: true,
      isShowAlert: false,
      textAlert: "",
      creditType: "",
      unitLabel: "",
      areaList: [],
      orderSelected: null,
      showModal: 0,
      orderTypeFilter: "ALL",
      orderStatusFilter: "ALL",
      orderCodeFilter: "",
      twoModals: false,
      pDateDesired: null,
      areasCredit: [],
      startDate: null,
      endDate: null,
      orderSortFilter: null,
      onlinePaymentAlert: false,
    };
    this.onDateChange = this.handleDateChange.bind(this);
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.IncreaseCredit"),
  });
  componentDidMount() {
    let { currentServer, serverUrl } = this.props.appReducer;
    const accessToken = currentServer.accessToken;
    var _serverUrl = serverUrl;
    if (!_serverUrl.endsWith("/")) {
      _serverUrl = _serverUrl + "/";
    }
    this.setState({ accessToken, serverUrl: _serverUrl }, () => {
      this.getBalanceAmount().then(() => {
        this.getUserAreas();
        this.setState({ isLoading: false });
      });
    });
  }
  // === show toast => toast native-base ===
  showToast = (message, status = "error") => {
    const toastDetail = {
      title: message,
      variant: "subtle",
      status,
    };
    Toast.show({
      duration: 2000,
      render: () => {
        return <ToastAlert {...toastDetail} />;
      },
    });
  };
  setIncreaseCreditAmount(creditType) {
    if (creditType == "userCredit") {
      this.increaseCredit(this.state.userAmount, creditType);
    } else if (creditType == "unitCredit") {
      this.increaseCredit(this.state.unitAmount, creditType);
    }
  }
  hideModal = () => {
    this.setState({
      showModal: 0,
      orderSelected: null,
    });
  };
  async getUnitsAmount(areas) {
    var areasAmount = [];
    for (var i in areas) {
      try {
        var unitAmount = await this.getBalanceAmount(areas[i]?.value);

        areasAmount.push({
          label: areas[i]?.label,
          amount: unitAmount,
          value: areas[i].value,
        });
      } catch (error) {
        console.log(error, "in get units amount");
      }
    }

    this.setState({ userAdminUnitAmount: areasAmount });
  }
  completeTextUserAlert(amount) {
    var textAlert = null;
    if (this.state.userAmountType == "thousand") {
      textAlert = `${translate(
        "increaseCredit.isUserCreditConfirm"
      )}${englishToPersianNumber(amount * Math.pow(10, 3), ",")}${translate(
        "increaseCredit.thousand"
      )}${translate("api.priceUnit")}${translate("increaseCredit.are")}`;
    } else if (this.state.userAmountType == "million") {
      textAlert = `${translate(
        "increaseCredit.isUserCreditConfirm"
      )}${englishToPersianNumber(amount * Math.pow(10, 3), ",")}${translate(
        "increaseCredit.million"
      )}${translate("api.priceUnit")}${translate("increaseCredit.are")}`;
    }
    this.showAlert(textAlert);
  }
  completeTextUnitAlert(amount, unitLabel) {
    var textAlert = null;
    if (this.state.unitAmountType == "thousand") {
      textAlert = `${translate("increaseCredit.isUnitCreditConfirm")}${
        this.state.unitLabel
      }${translate("increaseCredit.amountOfCredit")}${englishToPersianNumber(
        amount * Math.pow(10, 3),
        ","
      )}${translate("increaseCredit.thousand")}${translate(
        "api.priceUnit"
      )}${translate("increaseCredit.are")}`;
    } else if (this.state.unitAmountType == "million") {
      textAlert = `${translate("increaseCredit.isUnitCreditConfirm")}${
        this.state.unitLabel
      }${" "}${translate(
        "increaseCredit.amountOfCredit"
      )}${englishToPersianNumber(
        amount * Math.pow(10, 3),
        ","
      )}${" "}${translate("increaseCredit.million")}${" "}${translate(
        "api.priceUnit"
      )}${translate("increaseCredit.are")}`;
    }
    if (this.state.orderUnitId) {
      this.showAlert(textAlert);
    } else {
      this.showToast(translate("api.enterUnit"));
    }
  }
  showAlert(textMessage) {
    if (textMessage != null) {
      this.setState({ isShowAlert: true, textAlert: textMessage });
    }
  }
  getBalanceAmount(unitId = null) {
    return new Promise((resolve, reject) => {
      let { accessToken, serverUrl } = this.state;
      var url = serverUrl;
      url += `Services/GetBalance/`;
      var args = [];

      if (unitId != null) {
        args.push(`UnitCode=${unitId}`);
      }
      if (args.length > 0) {
        url += `?${args.join("&")}`;
      }
      fetch(url, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
            // this.setState({ isUserValid: "No" });
            resolve("");
            return;
          } else {
            this.setState(
              {
                userBalance: englishToPersianNumber(resj.userBalance, ","),
                unitBalance: englishToPersianNumber(resj.unitBalance, ","),
                isUserValid: "Yes",
              },
              () => {
                resolve(englishToPersianNumber(resj.unitBalance, ","));
              }
            );
          }
        })
        .catch((err) => {
          {
            console.log(err);
            // this.showToast(translate("api.getBalanceError"));
            reject(err);
          }
        });
    });
  }
  hideTwoModals = () => {
    this.setState({ twoModals: false });
  };
  hideIncreaseConfirm() {
    this.setState({
      isShowAlert: false,
      textAlert: "",
    });
  }
  onDateChange(date) {
    this.setState({ pDateDesired: date });
    this.hideTwoModals();
    return;
  }
  handleDateChange = (date, dateType) => {
    var selectedDate = moment(date).format("jYYYY/jM/jD");
    var parseDate = selectedDate.split("/");
    var pDate = parseDate[0];
    var mm = this.toDigit(parseDate[1]);
    var dd = this.toDigit(parseDate[2]);

    pDate = pDate + "/" + mm + "/" + dd;
    if (dateType == "START_DATE") {
      this.setState({ startDate: pDate });
    } else if (dateType == "END_DATE") {
      this.setState({ endDate: pDate });
      this.hideTwoModals();
    }
  };
  getUserAreas() {
    return new Promise((resolve, reject) => {
      let { serverUrl, accessToken } = this.state;
      var url = serverUrl;
      url += `Services/GetRibbonUserInUnit/`;
      fetch(url, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
            this.setState({ isUserValid: "No" });
          } else {
            var areas = [];
            if (Platform.OS === "web") {
              areas.push({
                label: translate("api.noUnitSelected"),
                boolUseUnitCredit: false,
                boolIncreaseUnitCredit: false,
                value: "",
              });
            }
            for (var i in resj) {
              if (resj[i].boolIncreaseUnitCredit)
                areas.push({
                  label: resj[i].strUnitName,
                  boolUseUnitCredit: resj[i].boolUseUnitCredit,
                  boolIncreaseUnitCredit: resj[i].boolIncreaseUnitCredit,
                  value: resj[i].numUnitRef,
                });
            }

            this.setState(
              {
                areaList: areas,
              },
              () => {
                this.getUnitsAmount(areas);
                this.props.MyOrders(
                  this.state.accessToken,
                  areas
                    .filter((o) => o.value > 0) // skip empty areaIds to prevent cast exception on server
                    .map((o) => {
                      return o.value;
                    })
                );
              }
            );
          }
          var areasBalance = [];
          if (areas != null) {
            for (var i in areas) {
              areasBalance.push({
                label: translate("increaseCredit.balance").concat(
                  " ",
                  areas[i].label
                ),
                value: this.state.areaList[i].value,
              });
            }

            areasBalance.unshift({
              label: translate("increaseCredit.userBalance"),
              value: "UserTransaction",
            });
            areasBalance.unshift({
              label: translate("increaseCredit.allBalance"),
              value: null,
            });
            // if (Platform.OS == "web") {
            //   areasBalance.unshift({
            //     label: translate("increaseCredit.balance"),
            //     value: "UserTransaction",
            //   });
            // }
          }
          this.setState({ areasCredit: areasBalance });
          resolve();
        })
        .catch((err) => {
          {
            console.log(err, "get userInUnit have error ");
            reject(err);
          }
        });
    });
  }

  handleOnItemPress = (orderData) => {
    this.setState({ orderSelected: orderData, showModal: 2 });
  };

  increaseCredit(amount, creditType) {
    if (
      Number.isInteger(amount) &&
      ((creditType == "unitCredit" && this.state.orderUnitId != null) ||
        creditType == "userCredit")
    ) {
      const paymentType = 4;
      let { serverUrl, accessToken } = this.state;
      var args = [];
      var requestID = [];
      var orderIsIncrease4Unit = true;
      var dateNow = new Date()
        .toLocaleDateString("fa-IR")
        .replace(/([۰-۹])/g, (token) =>
          String.fromCharCode(token.charCodeAt(0) - 1728)
        );
      var timeNow = new Date().toTimeString().split(" ")[0];
      if (this.state.creditType == "userCredit") {
        orderIsIncrease4Unit = false;
      }
      requestID.push(
        amount * Math.pow(10, 3),
        this.state.orderUnitId,
        orderIsIncrease4Unit,
        dateNow,
        timeNow
      );
      var requestId = requestID.join("-");
      args.push(`RequestID=${requestId}`);
      args.push(`paymentType=${paymentType}`);
      args.push(`Amount=${amount * Math.pow(10, 3)}`);
      args.push(`orderType=${"IncreaseCredit"}`);
      var url = `${serverUrl}Services/GetOnlinePaymentUrl/?${args.join("&")}`;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errorCode != null) {
            this.showToast(translate("api.orderAnswerError"));
          } else {
            if (orderIsIncrease4Unit) {
              this.setState({ paymentOnlineUnitUrl: resj.paymentUrl });
            } else {
              this.setState({ paymentOnlineUserUrl: resj.paymentUrl });
            }
          }
        })
        .catch((err) => {
          {
            console.log(err);
          }
        });
    }
  }
  paymentStatus(orderPayment, orderServiceType, statusCode = false) {
    const withdraw = "withdraw";
    const deposit = "deposit";
    if (orderPayment <= 0) {
      if (statusCode) {
        return "1";
      }
      return withdraw;
    }
    if (statusCode) {
      return "2";
    }
    return deposit;
  }
  toDigit(num) {
    if (Number(num) != NaN) {
      return (100 + Number(num)).toString().substr(1);
    }
    return num;
  }
  render() {
    if (this.state.isUserValid == "No") {
      return (
        <View
          style={{ alignItems: "center", flex: 1, justifyContent: "center" }}
        >
          <Text style={{ fontSize: 20, color: "#666666" }}>
            {translate("api.invalidUserReserveApi")}
          </Text>
        </View>
      );
    } else if (this.state.isLoading || this.props.reducer.isLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    } else if (this.state.isLoadingError) {
      return (
        <View
          style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
        >
          <Text
            style={{
              color: ArTheme.COLORS.ERROR,
              textAlign: "center",
            }}
          >
            {translate("app.loadingError")}
          </Text>
        </View>
      );
    }
    const startDate = this.state.pDateDesired
      ? this.state.pDateDesired.toString()
      : "";
    var allOrders = [...this.props.reducer.transactions];
    var orderList = [];
    orderList = allOrders.filter((o) => {
      if (
        (this.state.orderTypeFilter == "ALL" ||
          this.state.orderTypeFilter == o.data.strServiceTypeName ||
          this.state.orderTypeFilter === o.data.categories) &&
        (this.state.orderStatusFilter == "ALL" ||
          this.paymentStatus(o.data.numTransAmount, o.data.numServiceType) ===
            this.state.orderStatusFilter) &&
        (this.state.orderSortFilter == null ||
          this.state.orderSortFilter == o.data.numUnitCode ||
          (this.state.orderSortFilter == "UserTransaction" &&
            o.data.categories == this.state.orderSortFilter))
      ) {
        if (this.state.startDate != null) {
          var parseStDate = this.state.startDate.split("/");
          var yy = Number(parseStDate[0]);
          var mm = Number(parseStDate[1]);
          var dd = Number(parseStDate[2]);
          var parseOrderDate = o.data.dtRegisterPDate.split("/");
          var yyO = Number(parseOrderDate[0]);
          var mmO = Number(parseOrderDate[1]);
          var ddO = Number(parseOrderDate[2]);
          if (
            yyO > yy ||
            (yyO == yy && mmO > mm) ||
            (yyO == yy && mmO == mm && ddO >= dd)
          ) {
            if (this.state.endDate != null) {
              var parseStDate = this.state.endDate.split("/");
              var yy = Number(parseStDate[0]);
              var mm = Number(parseStDate[1]);
              var dd = Number(parseStDate[2]);
              var parseOrderDate = o.data.dtRegisterPDate.split("/");
              var yyO = Number(parseOrderDate[0]);
              var mmO = Number(parseOrderDate[1]);
              var ddO = Number(parseOrderDate[2]);
              if (
                yyO < yy ||
                (yyO == yy && mmO < mm) ||
                (yyO == yy && mmO == mm && ddO <= dd)
              ) {
                return true;
              } else if (this.state.endDate == null) {
                return true;
              }
            }
          }
        } else if (this.state.startDate == null) {
          return true;
        }
      }
    });
    if (allOrders && allOrders.length > 0) {
      this.orderStatuses = ["ALL"];
      for (var i in allOrders) {
        var status = this.paymentStatus(
          allOrders[i].data.numTransAmount,
          allOrders[i].data.numServiceType
        );
        if (this.orderStatuses.indexOf(status) < 0) {
          this.orderStatuses.push(status);
        }
      }
    }

    if (allOrders && allOrders.length > 0) {
      for (var i in allOrders) {
        var typ = allOrders[i].data.strServiceTypeName;
        if (this.orderTypes.indexOf(typ) < 0) {
          this.orderTypes.push(typ);
        }
      }
    }
    orderList.sort((a, b) => (a.id < b.id ? 1 : -1));

    return (
      <KeyboardAvoidingView behavior="padding" style={{ flex: 1 }}>
        {this.state.isUserValid == "Yes" && !this.state.isNewOrder && (
          <View style={{ flex: 1 }}>
            <FilterItem
              listItem={this.orderTypes.map((s) => {
                return { value: s, text: translate(`api.orderTypes.${s}`) };
              })}
              selectedItem={this.state.orderTypeFilter || this.orderTypes[0]}
              onSelect={(item) => {
                this.setState({
                  orderTypeFilter: item,
                });
              }}
            />
            <FilterItem
              listItem={this.orderStatuses?.map((s) => {
                return { value: s, text: translate(`api.orderStatuses.${s}`) };
              })}
              selectedItem={
                this.state.orderStatusFilter || this.orderStatuses[0]
              }
              onSelect={(item) => {
                this.setState({ orderStatusFilter: item });
              }}
            />
            <View
              style={{
                flexDirection: "row",
                // paddingStart: 10,
                paddingEnd: 10,
                paddingTop: 5,
                paddingStart: 10,
                height: 67,
                backgroundColor: ArTheme.COLORS.BORDER_COLOR,
                borderBottomWidth: 1,
                borderColor: ArTheme.COLORS.BORDER,
              }}
            >
              <TouchableHighlight
                onPress={() => {
                  this.setState({ twoModals: true });
                }}
                underlayColor={ArTheme.COLORS.BORDER}
                style={{
                  borderColor: ArTheme.COLORS.BORDER,
                  borderWidth: 1,
                  borderRadius: 4,
                  backgroundColor: "#FFFFFF",
                  shadowColor: ArTheme.COLORS.BLACK,
                  shadowOffset: { width: 0, height: 1 },
                  shadowRadius: 2,
                  shadowOpacity: 0.05,
                  elevation: 2,
                  paddingStart: 5,
                  paddingEnd: 10,
                  marginTop: 8,
                  height: 45,
                  flex: this.state.areaList.length == 0 ? 1 : null,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    padding: 10,
                  }}
                >
                  <FontAwesomeIcon icon={faCalendar} color="gray" size={20} />
                  {this.state.startDate != null && (
                    <Text
                      style={{
                        paddingEnd: 6,
                        fontFamily: "IRANSansWebFaNum",
                        fontSize: 12,
                      }}
                    >
                      {this.state.startDate}
                      {this.state.endDate != null && (
                        <Text>
                          {"-"}
                          {this.state.endDate}
                        </Text>
                      )}
                    </Text>
                  )}
                  {this.state.startDate == null && (
                    <Text
                      style={{
                        paddingEnd: 6,
                        fontFamily: "IRANSansWebFaNum",
                        fontSize: 12,
                      }}
                    >
                      {translate("api.orderSortByDate")}
                    </Text>
                  )}
                </View>
              </TouchableHighlight>
              <ModalBase
                avoidKeyboard={true}
                isOpen={this.state.twoModals}
                onClose={() => this.hideTwoModals()}
              >
                <View
                  style={{
                    justifyContent: "center",
                    backgroundColor: "#fff",
                    alignItems: "center",
                    borderRadius: 5,
                    marginTop: 15,
                    padding: 10,
                  }}
                >
                  <PersianCalendarPicker
                    textStyle={{ fontFamily: "IRANSansWebFaNum" }}
                    // minDate={new Date().toLocaleDateString("fa-IR")}
                    onDateChange={this.handleDateChange}
                    selectedDayColor="blue"
                    allowRangeSelection={true}
                    scaleFactor={SCREEN_WIDTH * 1.2}
                    selectedRangeStyle={{}}
                    // minRangeDuration={new Date().toLocaleDateString("fa-IR")}
                  ></PersianCalendarPicker>
                </View>
              </ModalBase>
              {this.state.areaList.length != 0 && (
                <View style={{ flex: 1, marginStart: 10, marginTop: 8 }}>
                  <Select
                    placeholder={translate("increaseCredit.balance")}
                    data={this.state.areasCredit}
                    value={
                      Platform.OS == "web"
                        ? this.state.orderSortFilter
                        : translate("increaseCredit.balance") ||
                          this.state.orderSortFilter
                    }
                    onChangeText={(value, index, data) => {
                      this.setState({ orderSortFilter: value });
                    }}
                  />
                </View>
              )}
            </View>
            <ScrollView
              style={{
                flex: 1,
                marginBottom: 85,
              }}
            >
              {orderList.map((o, i) => {
                return (
                  <TransactionListItem
                    onPress={() => this.handleOnItemPress(o.data)}
                    key={i}
                    orderData={o.data}
                    toast={this.showToast}
                  />
                );
              })}
            </ScrollView>
          </View>
        )}
        {/* details order */}
        <ModalBase
          avoidKeyboard={true}
          isOpen={this.state.showModal === 2}
          onClose={() => this.hideModal()}
        >
          <View style={[style.modalInsideWrapper, { flex: 1 }]}>
            <View
              style={[
                Platform.OS == "web"
                  ? style.webModalDetails
                  : style.appModalDetails,
              ]}
            >
              {/* start Icons */}
              <HStack
                space="2"
                alignItems="center"
                style={{
                  borderColor: ArTheme.COLORS.BORDER,
                  borderBottomWidth: 1,
                  height: 77,
                  width: "100%",
                }}
              >
                {this.state.orderSelected != null && (
                  <IconButton
                    style={{
                      backgroundColor: "#ffffff",
                      width: 50,
                      height: 50,
                      borderRadius: 35,
                      borderWidth: 1,
                      borderColor: "#ccf",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    icon={{
                      code: getIconPicture(
                        "facilityIcons",
                        this.state.orderSelected.numServiceType
                      ),
                      style: {
                        fontFamily: FONT_FAMILIES.PRO_REGULAR,
                        fontSize: 20,
                        color: getIconPicture(
                          "facilityIcons",
                          this.state.orderSelected.numServiceType
                        )
                          ? "#006666"
                          : "#ccc",
                      },
                    }}
                  />
                )}
                <View
                  style={{
                    flex: 1,
                    marginTop: 5,
                    flexDirection: "column",
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {this.state.orderSelected != null && (
                      <Text>
                        {translate("api.orderId")} :
                        <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                          {" "}
                          {englishToPersianNumber(
                            this.state.orderSelected.numRequestID,
                            ""
                          )}
                        </Text>
                      </Text>
                    )}

                    {this.state.orderSelected?.strUnitName != null && (
                      <Text>{this.state.orderSelected.strUnitName}</Text>
                    )}
                  </View>
                  {this.state.orderSelected != null && (
                    <Text style={{ marginTop: 6 }}>
                      {translate("api.orderSelectedType")} :{" "}
                      {this.state.orderSelected.strServiceTypeName}
                    </Text>
                  )}
                </View>
                {this.state.orderSelected != null && (
                  <IconButton
                    style={{
                      backgroundColor: "#ffffff",
                      width: 50,
                      height: 50,
                      borderRadius: 35,
                      borderWidth: 1,
                      borderColor: "#ccf",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    icon={{
                      code: getIconPicture(
                        "statusOrder",
                        this.paymentStatus(
                          this.state.orderSelected.numTransAmount,
                          this.state.orderSelected.numServiceType
                        )
                      ),
                      style: {
                        fontFamily: FONT_FAMILIES.PRO_REGULAR,
                        fontSize: 20,
                        color: "#999",
                      },
                    }}
                  />
                )}
              </HStack>
              {/* texts */}
              <View
                style={{
                  padding: 5,
                  flex: 1,
                  width: "100%",
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: Platform.OS == "web" ? 0 : 27,
                  }}
                >
                  {this.state.orderSelected?.strRibbonUserName != null && (
                    <Text style={{ fontWeight: "bold", marginBottom: 2 }}>
                      {translate("increaseCredit.client")}
                      {":"}
                      {this.state.orderSelected.strRibbonUserName}{" "}
                    </Text>
                  )}
                  {this.state.orderSelected?.strUnitName != null && (
                    <Text style={{ fontWeight: "bold", marginBottom: 2 }}>
                      {translate("increaseCredit.client")}
                      {":"}
                      {this.state.orderSelected.strUnitName}{" "}
                    </Text>
                  )}
                </View>

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "100%",
                    marginBottom: 10,
                  }}
                >
                  {this.state.orderSelected != null && (
                    <Text>
                      {translate("api.orderSelectedDate")} :
                      <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                        {" "}
                        {englishToPersianNumber(
                          this.state.orderSelected.dtRegisterPDate
                        )}
                      </Text>
                    </Text>
                  )}
                  {this.state.orderSelected != null && (
                    <Text>
                      {translate("api.orderSelectedTime")} :
                      <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                        {" "}
                        {englishToPersianNumber(
                          this.state.orderSelected.dtRegisterTime
                        )}
                      </Text>
                    </Text>
                  )}
                </View>
                {this.state.orderSelected != null && (
                  <View
                    style={{
                      alignItems: "flex-end",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Text
                      style={{
                        alignItems: "flex-end",
                        fontWeight: "bold",
                      }}
                    >
                      {translate("api.orderPrice")} {": "}
                      <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                        {englishToPersianNumber(
                          this.state.orderSelected.numTransAmount,
                          ","
                        )}
                      </Text>{" "}
                      <Text>{translate("api.priceUnit")}</Text>
                    </Text>
                    {this.state.orderSelected != null && (
                      <Text
                        style={{
                          alignItems: "flex-end",
                          fontWeight: "bold",
                        }}
                      >
                        {translate("increaseCredit.credit")}
                        <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                          {": "}
                          {englishToPersianNumber(
                            this.state.orderSelected.numAfterBalance,
                            ","
                          )}{" "}
                        </Text>
                        <Text>{translate("api.priceUnit")}</Text>
                      </Text>
                    )}
                  </View>
                )}
                <View>
                  {this.state.orderSelected != null && (
                    <Text>
                      {translate("api.paymentStatusString")}
                      {": "}
                      {translate(
                        "api.paymentStatusCode".concat(
                          ".",
                          this.paymentStatus(
                            this.state.orderSelected.numTransAmount,
                            this.state.orderSelected.numServiceType,
                            true
                          )
                        )
                      )}
                    </Text>
                  )}
                </View>
                <View style={{ flexDirection: "column" }}>
                  {this.state.orderSelected != null && (
                    <Text>
                      {translate("api.orderDesc")}
                      {": "}
                      {this.state.orderSelected.strTransDesc}
                    </Text>
                  )}
                </View>
              </View>

              {/* end buttons */}
              <ArButton
                style={{ width: "100%", marginBottom: 0 }}
                onPress={() => this.hideModal()}
              >
                {translate("api.closeOrderSelected")}
              </ArButton>
            </View>
          </View>
        </ModalBase>
        {this.state.isUserValid == "Yes" && this.state.isNewOrder && (
          <View
            style={{
              flexDirection: "column",
              justifyContent: "space-between",
              flex: 1,
            }}
          >
            {/* increase user credit  */}
            <View style={{ flexDirection: "column", flex: 1 }}>
              <ScrollView style={{ flexGrow: 1, flex: 1, marginBottom: 14 }}>
                <CreditCard
                  title={translate("increaseCredit.userBalance")}
                  amountText={translate("increaseCredit.yourBalance")}
                  creditUserAmount={this.state.userBalance}
                  baseAmount={this.state.baseUserAmount}
                  // isIncreasing={this.state.creditType == "userCredit"}
                  selectAmount={(amount) => {
                    this.setState({
                      userAmount: amount,
                      onlinePaymentAlert: false,
                    });
                  }}
                  selectUnit={(unitCode, unitLabel) => {
                    this.setState({
                      orderUnitId: unitCode,
                      unitLabel: unitLabel,
                      onlinePaymentAlert: false,
                    });
                  }}
                  userAmount={this.state.userAmount}
                  onlineGateway={this.state.onlinePaymentAlert}
                  onlineUrl={this.state.paymentOnlineUserUrl}
                  onPressOnlinePayment={(orderAmountType, showAlert = true) => {
                    this.setState(
                      {
                        userAmountType: orderAmountType,
                        creditType: "userCredit",
                      },
                      () => {
                        showAlert &&
                          this.completeTextUserAlert(this.state.userAmount);
                      }
                    );
                  }}
                ></CreditCard>
                {this.state.areaList.length != 0 && (
                  <CreditCard
                    title={translate("increaseCredit.unitBalance")}
                    amountText={translate("increaseCredit.yourUnitBalance")}
                    creditUnitsAmount={this.state.userAdminUnitAmount}
                    areaList={this.state.areaList}
                    lengthOfArea={this.state.areaList.length}
                    userAmount={this.state.unitAmount}
                    baseAmount={this.state.baseUnitAmount}
                    onlineGateway={this.state.onlinePaymentAlert}
                    onlineUrl={this.state.paymentOnlineUnitUrl}
                    // isIncreasing={this.state.creditType == "unitCredit"}
                    selectAmount={(amount) => {
                      this.setState({
                        unitAmount: amount,
                        onlinePaymentAlert: false,
                      });
                    }}
                    selectUnit={(unitCode, unitLabel) => {
                      this.setState({
                        orderUnitId: unitCode,
                        unitLabel: unitLabel,
                        onlinePaymentAlert: false,
                      });
                    }}
                    onPressOnlinePayment={(
                      orderAmountType,
                      showAlert = true
                    ) => {
                      this.setState(
                        {
                          unitAmountType: orderAmountType,
                          creditType: "unitCredit",
                        },
                        () => {
                          showAlert &&
                            this.completeTextUnitAlert(
                              this.state.unitAmount,
                              this.state.unitLabel
                            );
                        }
                      );
                    }}
                  ></CreditCard>
                )}
              </ScrollView>
            </View>
            <View style={style.alignButton}>
              <TouchableHighlight
                underlayColor={ArTheme.COLORS.BORDER}
                onPress={() => {
                  this.setState({ isNewOrder: false });
                }}
                color="primary"
                iconColor="#fff"
                shadowColor={true}
                style={{
                  backgroundColor: ArTheme.COLORS.PRIMARY,
                  borderWidth: 1,
                  // backgroundColor: "#fff",
                  borderColor: "#808080",
                  borderRadius: 5,
                  height: 42,
                  padding: 9,
                  width: 160,
                }}
              >
                <View
                  style={{
                    // flexDirection: "row",
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    paddingBottom: 3,
                  }}
                >
                  <Text
                    style={{
                      textAlign: "center",
                      textAlign: "center",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: 17,
                      // marginEnd: -47,
                    }}
                  >
                    {translate("increaseCredit.reports")}
                  </Text>
                  {/* <FontAwesomeIcon
                    icon={faPlus}
                    color="#FFF"
                    size={20}
                    style={{ marginBottom: -30, paddingBottom: -30 }}
                  /> */}
                </View>
              </TouchableHighlight>
            </View>
          </View>
        )}
        {this.state.isShowAlert && (
          <AlertDialogBase
            isOpen={true}
            title={translate("increaseCredit.titleConfirm")}
            confirmText={translate("app.confirm")}
            colorConfirm="primary"
            confirmHandler={() => {
              this.setIncreaseCreditAmount(this.state.creditType);
              this.hideIncreaseConfirm();
              this.setState({ onlinePaymentAlert: true });
            }}
            onClose={() => {
              this.hideIncreaseConfirm();
              this.setState({ onlinePaymentAlert: false });
            }}
          >
            <Text>{this.state.textAlert}</Text>
          </AlertDialogBase>
        )}
      </KeyboardAvoidingView>
    );
  }
}
const style = StyleSheet.create({
  btnAdd: {
    width: 180,
    height: 50,
    borderRadius: 5,
    backgroundColor: ArTheme.COLORS.PRIMARY,
    position: "absolute",
    bottom: 15,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  creditStyle: {
    flexDirection: "column",
    backgroundColor: "#fff",
    // width: "95%",
    flex: 1,
    padding: 0,
    borderColor: "#5b5b5a",
    borderRadius: 8,
    borderWidth: 1,
    justifyContent: "space-between",
    minHeight: 200,
    marginBottom: 8,
    marginStart: 7,
    marginEnd: 7,
    marginTop: 4,
  },
  title: {
    fontWeight: "bold",
    fontSize: 20,
    paddingBottom: 7,
    paddingTop: 5,
    backgroundColor: "#C0C0C0",
    paddingStart: 5,
    paddingEnd: 5,
  },
  body: {
    fontSize: 18,
    paddingStart: 5,
    paddingEnd: 5,
    marginTop: -13,
    marginBottom: -3,
  },
  alignButton: {
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 14,
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
    marginBottom: 16,
    marginTop: 16,
  },
  webModalDetails: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 300,
    marginTop: 7,
    width: "100%",
  },
  appModalDetails: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 300,
    marginTop: 7,
    width: "100%",
  },

  modalInsideWrapper: {
    backgroundColor: "#FFF",
    borderRadius: 10,
    marginTop: 5,
    marginBottom: 0,
    padding: 5,

    alignItems: "center",
  },
});
const mapStateToProps = (state) => {
  return {
    reducer: state.ApiReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    MyOrders: (accessToken, userUnit) => {
      dispatch(Actions.MyTransactions(accessToken, userUnit));
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IncreaseCreditScreen);
